<template>
    <div class="section full-white-border">
        <div class="bet-slip-item-container">
            <v-container fluid px-0 py-0>
                <table>
                    <thead>
                        <tr>
                            <td class="px-0 bet-leg text-center">{{betLeg}}.</td>
                            <td class="betslip-item-header" v-if="betSelection.marketDetailStatus !== 1 || betSelection.marketStatusId !== 1 || betSelection.betleg.odds === 0">{{betSelection.betType}}<span class="detail-status">SUSPENDED</span></td>
                            <td v-else class="betslip-item-header">{{betSelection.betType}}</td>
                            <td class="py-0">
                                <a @click="removeBet(betSelection)" :class="{disabledClick : $store.getters.isSubmitting}">
                                    <i class="material-icons">clear</i>
                                </a>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="3">
                                <table class="box">
                                    <tr>
                                        <td></td>
                                        <td class="betslip-item">{{betSelection.sport}} - {{betSelection.time | date}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td class="betslip-item">{{betSelection.tournament}}</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td class="betslip-item">{{betSelection.event}}</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="2" class="betslip-item-uppercase">{{betSelection.market}}</td>
                            <td v-if="betSelection.marketDetailStatus !== 1 || betSelection.marketStatusId !== 1 || betSelection.betleg.odds === 0"><i class="material-icons lock-icon">lock</i></td>
                            <td v-else class="odds">
                                {{betSelection.betleg.odds}}
                                <transition name="oddIncrease">
                                    <div @animationend="destroy(betSelection)" v-if="betSelection.css === 'oddIncrease'">
                                    </div>
                                </transition>
                                <transition name="oddDecrease">
                                    <div @animationend="destroy(betSelection)" v-if="betSelection.css === 'oddDecrease'">
                                    </div>
                                </transition>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                <v-layout wrap>
                    <v-flex xs12 md6 class="border">
                        <v-text-field v-model="betSelection.betleg.stake" type=number :hide-details="hideTextFieldHints" min="0" box label="Stake" :disabled="betSelection.betleg.submitting" @input="calculatePayout()" required></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 class="border">
                        <v-text-field :value="this.$store.getters.payoutAmount(betSelection.marketDetailId)" :hide-details="hideTextFieldHints" box label="Payout" disabled></v-text-field>
                    </v-flex>
                </v-layout>
            </v-container>
            <template v-if="betSelection && betSelection.errorMessage && betSelection.errorMessage.indexOf('Failure')!==-1">
                <v-btn class="btn-submit" color="green" v-on:click="acceptChanges(betSelection)">
                    Accept changes
                </v-btn>
            </template>
            <template v-else-if="$store.getters.getAcceptedChanges(betSelection.marketDetailId)">
                <v-btn class="btn-submit" color="blue" v-on:click="submitNow(betSelection)">
                    SUBMIT NOW
                </v-btn>
                <v-alert :value="betSelection.success" dismissible type="success">
                    Bet Successfully Placed.
                </v-alert>
            </template>
            <template v-else-if="!$store.getters.getAcceptedChanges(betSelection.marketDetailId)">
                <v-btn v-if="!betSelection.success" :disabled="(timeout||betSelection.marketDetailStatus !== 1 || betSelection.betleg.stake < 1)" class="btn-submit" color="green" v-on:click="checkLoggedIn(betSelection)">
                    {{submitText}}
                </v-btn>
                <v-alert :value="betSelection.success" dismissible type="success" @input="dismissBetSuccessMessage(betSelection)">
                    Bet Successfully Placed.
                </v-alert>
                <v-alert v-model="betSelection.error" dismissible type="error">
                    {{betSelection.errorMessage}}
                </v-alert>
            </template>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import Utils from '../utils/utils';
    export default {
        name: 'BetSlipItem',
        props: {
            betLeg: Number,
            betSelection: Object,
            betSubmit: Function,
            removeBet: Function
        },
        data() {
            return {
                submitText: "SUBMIT BET",
                timeout: false,
                countDown: 10,
                hideTextFieldHints: true,
                submittingNow: false
            }
        },
        computed: {
            Autheticated() {
                return this.$store.getters.isAutheticated
            }
        },
        methods: {
            destroy(betSelection) {
                Vue.set(betSelection, 'css', '')
            },
            startCountdown(betSelection) {
                let currentStateOfBetSelection = Utils.deepClone(betSelection);
                let priceDrift = this.$store.getters.selectedOddsChange;
                this.$store.dispatch('setSelectionSubmission', { marketDetailId: currentStateOfBetSelection.marketDetailId, success: false, error: false, errorMessage: '', submitting: true });
                this.timeout = true;
                this.$store.dispatch('setIsSubmitting', true);
                let setCountDown = setInterval(() => {
                    this.$store.dispatch('setIsSubmitting', true);
                    this.countDown--;
                    this.submitText = 'Wait ' + this.countDown;
                    if (this.countDown === 0) {
                        if (priceDrift === 'Accept any odds change') {
                            clearInterval(setCountDown);
                            this.submitText = 'Submit Bet';
                            this.timeout = false;
                            this.countDown = 10;
                            this.betSubmit(betSelection);
                            this.$store.dispatch('setIsSubmitting', false);
                        }
                        else if (priceDrift === 'Accept higher odds change') {
                            if (currentStateOfBetSelection.betleg.odds > betSelection.betleg.odds) {
                                clearInterval(setCountDown);
                                this.submitText = 'Submit Bet';
                                this.timeout = false;
                                this.countDown = 10;
                                this.betSubmit(currentStateOfBetSelection);
                                this.$store.dispatch('setIsSubmitting', false);
                            }
                            else {
                                clearInterval(setCountDown);
                                this.submitText = 'Submit Bet';
                                this.timeout = false;
                                this.countDown = 10;
                                this.betSubmit(betSelection);
                                this.$store.dispatch('setIsSubmitting', false);
                            }
                        }
                        else {
                            clearInterval(setCountDown);
                            this.submitText = 'Submit Bet';
                            this.timeout = false;
                            this.countDown = 10;
                            this.betSubmit(currentStateOfBetSelection);
                            this.$store.dispatch('setIsSubmitting', false);
                        }
                    }
                }, 1000);
                return this.countDown * 1000;
            },
            checkLoggedIn(betSelection) {
                let store = this.$store;
                store.dispatch('storeCookieAccessToken').then(() => {
                    if (store.getters.accessToken !== null) {
                        store.dispatch('login', {
                            authToken: store.getters.accessToken }).then(() => {
                            this.startCountdown(betSelection);
                        })
                    } else {
                        store.dispatch('setSelectionSubmission', { marketDetailId: betSelection.marketDetailId, success: false, error: true, errorMessage: 'You need to be logged in to submit a bet', submitting: false });
                    }
                });
                
            },
            calculatePayout() {
                if (this.betSelection.betleg.stake && this.betSelection.betleg.odds > 0) {
                    this.$store.dispatch('setPayoutAmount', this.betSelection.betleg);
                }
            },
            submitNow(betSelection) {
                let priceDrift = this.$store.getters.selectedOddsChange;
                let currentStateOfBetSelection = Object.assign({}, betSelection);
                //this.$store.dispatch('setselectedOddsChange', 3)
                this.$store.dispatch('setselectedOddsChange', priceDrift)
                this.betSelection.accepted = false;
                this.$store.dispatch('setAcceptedChanges', this.betSelection);
                this.submittingNow = false;
                this.betSubmit(currentStateOfBetSelection);
            },
            acceptChanges(betSelection) {
                this.$store.dispatch('setSelectionSubmission', { marketDetailId: betSelection.marketDetailId, success: false, error: false, errorMessage: '', submitting: true });
                this.betSelection.accepted = true;
                this.$store.dispatch('setAcceptedChanges', this.betSelection);
                this.submittingNow = true;
                this.calculatePayout();
            },
            dismissBetSuccessMessage(betSelection) {
                this.$store.dispatch('setSelectionSubmission', { marketDetailId: betSelection.marketDetailId, success: false, error: false, errorMessage: '', submitting: false });
            }
        }
    }
</script>

<style scoped>
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        .odds {
            padding-right: 10px !important;
        }

        .oddIncrease-enter-active {
            right: 0px !important;
            bottom: 0px !important;
            top: 10px !important;
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent;
        }

        .oddDecrease-enter-active {
            right: 0px !important;
            bottom: 0px !important;
            top: 10px !important;
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent;
        }
    }

    @supports (-ms-ime-align:auto) {
        .odds {
            padding-right: 10px;
        }

        .oddIncrease-enter-active {
            right: 0px !important;
            bottom: 0px !important;
            transform: translateY(-8px);
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent;
        }

        .oddDecrease-enter-active {
            right: 0px !important;
            bottom: 0px !important;
            transform: translateY(-8px) rotate(90deg) !important;
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent;
        }
    }

    .border {
        border: 1px solid #fff !important;
    }

	@media (min-width:989px) {
		.border:last-child {
			border-left: none !important;
		}
	}

    .btn-submit {
        width: 100%;
        margin: 16px 0px;
        display: inline-block;
        font-weight: 600;
    }

    .material-icons {
        color: red;
        font-weight: bolder;
        position: relative;
        left: 15px;
        font-size: 18px;
    }

    .disabledClick {
        pointer-events: none;
        cursor: default;
    }

    .disabledClick .material-icons {
        color: grey;
        font-weight: bolder;
    }

    .lock-icon {
        color: white;
        font-weight: bolder;
    }

    .detail-status {
        background: #616161;
        color: #fff;
        display: inline-block;
        border-radius: 3px;
        white-space: pre-wrap;
        font-size: 85%;
        font-weight: 900;
        line-height: 1.5;
        font-family: monospace, monospace;
        padding-left: 4px;
        padding-right: 4px;
        top: -1px;
        position: relative;
        margin-left: 10px;
    }

    .odds {
        color: gold;
        font-size: 12px;
        font-weight: 300;
        text-align: right;
    }

    .oddIncrease-enter-active {
        animation: increase 6s;
        position: absolute;
        bottom: 9px;
        right: -14px;
    }

    @keyframes increase {
        100% {
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent #2ad100 transparent transparent;
        }

        80% {
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent transparent transparent transparent;
        }

        60% {
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent #2ad100 transparent transparent;
        }

        40% {
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent transparent transparent transparent;
        }

        20% {
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent #2ad100 transparent transparent;
        }

        0% {
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent transparent transparent transparent;
        }
    }

    .oddDecrease-enter-active {
        animation: decrease 6s;
        position: absolute;
        bottom: 8px;
        right: -15px;
        transform: rotate(90deg);
    }

    @keyframes decrease {
        100% {
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent #f50000 transparent transparent;
        }

        80% {
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent transparent transparent transparent;
        }

        60% {
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent #f50000 transparent transparent;
        }

        40% {
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent transparent transparent transparent;
        }

        20% {
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent #f50000 transparent transparent;
        }

        0% {
            border-style: solid;
            border-width: 0 10px 10px 0;
            border-color: transparent transparent transparent transparent;
        }
    }

    .betslip-item {
        color: #efefef;
        font-size: 12px;
        font-weight: normal;
    }

    .box {
        padding: 10px;
        border: 1px solid #fff;
        border-radius: 2px;
        background-color: #2b2b2b;
        margin-top: 5px;
    }

    .betslip-item-header {
        color: white;
        font-size: 11px;
        line-height: 17px;
        padding-left: 10px;
        text-align: left;
        padding-bottom: 1px;
        text-transform: uppercase;
        width: 100%;
    }

    .bet-slip-item-container table {
        width: 100%;
        border-spacing: 0;
    }

    .bet-slip-item-container table thead {
        width: 100%;
    }

    .bet-slip-item-container table thead td:nth-child(3) {
        padding-right: 15px;
    }

    .bet-slip-item-container tfoot td.odds {
        left: -15px;
        position: relative;
    }

    .bet-slip-item-container button.btn-submit {
        height: 30px;
        font-size: 12px;
    }

    .betslip-item-uppercase {
        color: gold;
        font-size: 11px;
        padding: 7px 0px;
        text-transform: uppercase;
    }

    @media(max-width:320px) {
        .box {
            padding: 5px 5px 5px 5px !important;
        }

        .betslip-item {
            font-size: 11px;
        }

        .betslip-item-header {
            font-size: 14px;
            padding-bottom: 0px;
        }

        .betslip-item-uppercase {
            font-size: 14px
        }

        .odds {
            font-size: 16px;
        }
    }

    .bet-leg {
        font-size: 12px;
        font-weight: normal;
    }

    .text-center {
        text-align: center;
    }

    .section {
        background-color: #363636;
        padding: 7px 10px 0px 10px;
    }

    .v-label {
        font-size: 11px;
    }
</style>